"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePublicDataClient = usePublicDataClient;
const PublicDataClient_1 = require("@juvare/platform-sdk-js/PublicDataClient");
const react_1 = __importDefault(require("react"));
function usePublicDataClient(appName, baseUrl) {
    return react_1.default.useMemo(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resolvedAppName = appName ?? window.appName;
        if (!resolvedAppName) {
            throw new Error('App name is unknown, please either set window.appName or pass appName as an argument to this hook');
        }
        return new PublicDataClient_1.PublicDataClient(resolvedAppName, baseUrl);
    }, [appName, baseUrl]);
}
